<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe-row" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">RD Sigla</label>
                <input type="text" v-model="objEdicao.rdsigla" maxlength="10" v-uppercase />
            </div>

            <div class="form-item">
                <label class="label-caption">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmrd" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Pz Dias</label>
                <input type="text" class="input-right" v-model="objEdicao.pzdias" maxlength="3" v-number />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Pz Meses</label>
                <input type="text" class="input-right" v-model="objEdicao.pzmeses" maxlength="3" v-number />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Observações/Critérios</label>
                <textarea v-model="objEdicao.obs" maxlength="3000" rows="5" style="resize: none;"/>
            </div>
        </div>

        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarEpRd } from '@/models/epRd';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarEpRd());


const cancelForm = () => {emit('close');}


const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('ep_rd', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
        }
        objEdicao.value.idlogin         = globalStore.idlogin;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
    } catch (error) {msgAlerta.value = error;
    }finally{isLoading.value=false;}
}

const salvarDados = async() => {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    
    if (!objEdicao.value.rdsigla || objEdicao.value.rdsigla.trim() === '') {msgAlerta.value='Informe a sigla do Risco de Desempenho'; return;}
    if (!objEdicao.value.nmrd || objEdicao.value.nmrd.trim() === '') {msgAlerta.value='Informe o Nome/Descrição'; return;}
    try {
        isLoading.value             = true;
        msgAlerta.value                   = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        const response              = await Api.genericPut('/cad/ep_rd', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error) {msgAlerta.value = error;
    } finally{isLoading.value=false;}
}

function validarDados(){
    let x = '';
    let r = Validar.texto(objEdicao.value.rdsigla, '\n-Informe a sigla do Risco de Desempenho');
    if (!r.ok) x += r.msg;
    r = Validar.texto(objEdicao.value.nmrd, '\n-Informe o Nome/Descrição');
    if (!r.ok) x += r.msg;
    r = Validar.texto(objEdicao.value.pzdias, '\n-Informe o prazo em dias mesmo que = ZERO');
    if (!r.ok) x += r.msg;
    r = Validar.texto(objEdicao.value.pzmeses, '\n-Informe o prazo em meses mesmo que = ZERO');
    if (!r.ok) x += r.msg;
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}

onMounted(lerDados)
</script>